import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as successApiCall from '../../../actionCreators/success';
import DropDown from '../Common/Dropdown';
import Tooltip from '../../../CommonComponents/UIComponents/ToolTip/Tooltip';
// import OverlayTrigger from '../../../CommonComponents/UIComponents/OverlayTrigger/OverlayTrigger';

import './Prescriptions.scss';

const Prescriptions = props => {
  const {
    dataLocale,
    localeInfo,
    powersDetail,
    showRefDD,
    errorMsg,
    successApiCall,
    enterData,
    setTouchFields,
    touchFields,
    lensType,
    currentItemData,
  } = props;
  const { domainUrl } = localeInfo;
  const {
    TO_LEARN_MORE,
    THIS_IS_YOUR_MAIN_POWER,
    ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION,
    ONLY_IF_YOU_HAVE_CYL,
    NOT_ALL_POWERS_HAVE_CYLINDER,
    CLICK_HERE,
    EYE,
    RIGHT_EYE,
    LEFT_EYE,
    PLEASE_ENTER_FITTING_HEIGHT,
    ENTERED_FITTING_HEIGHT,
  } = dataLocale;

  const openDropdown = (props, data) => {
    successApiCall.showPowerDD(data);
  };

  let hasSingleEye = false;
  let whichEye;
  if (lensType?.toLowerCase() === 'contact_lens') {
    hasSingleEye = !(
      currentItemData?.prescription?.left &&
      Object.keys(currentItemData?.prescription?.left).length > 0 &&
      currentItemData?.prescription?.right &&
      Object.keys(currentItemData?.prescription?.right).length > 0
    );
    if (hasSingleEye)
      whichEye =
        currentItemData?.prescription?.left &&
        Object.keys(currentItemData?.prescription?.left).length > 0
          ? 'left'
          : 'right';
  }

  const handlePowerValidation = enterData => {
    if (lensType?.toLowerCase() === 'bifocal' && !enterData?.left?.bottomDistance) {
      successApiCall.enterErrorFunc(PLEASE_ENTER_FITTING_HEIGHT);
      return;
    }
    if (lensType?.toLowerCase() === 'bifocal' && enterData?.left?.bottomDistance > 32) {
      successApiCall.enterErrorFunc(`${ENTERED_FITTING_HEIGHT} > 32`);
      return;
    }
    successApiCall.enterErrorFunc('');
  };

  const handleProductList = (prop, data) => {
    const { power, name } = prop;
    if (data === 'Select' || data === 'Please select') {
      data = '';
    }
    const dataObj = { ...enterData };
    dataObj[name][power] = data;
    if (power === 'cyl' && data === '') {
      dataObj[name].axis = '';
    }
    successApiCall.enterDataFunc(dataObj);
    successApiCall.showPowerDD('');
    handlePowerValidation(dataObj);
    if (touchFields && touchFields.prescription !== true)
      setTouchFields({ ...touchFields, prescription: true });
  };

  const Spherical = (
    <Tooltip id="Spherical">
      {THIS_IS_YOUR_MAIN_POWER}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const Cylindrical = (
    <Tooltip id="Cylindrical">
      {ONLY_IF_YOU_HAVE_CYL}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_balnk"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const Axis = (
    <Tooltip id="Axis">
      {NOT_ALL_POWERS_HAVE_CYLINDER}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>{' '}
    </Tooltip>
  );
  const AP = (
    <Tooltip id="AP">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const PD_ = (
    <Tooltip id="PD">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const NEARPD = (
    <Tooltip id="NEARPD">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const LENSHEIGHT = (
    <Tooltip id="LENSHEIGHT">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const LENSWIDTH = (
    <Tooltip id="LENSWIDTH">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const FITTINGHEIGHT = (
    <Tooltip id="FITTINGHEIGHT">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const ED = (
    <Tooltip id="ED">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const DBL = (
    <Tooltip id="DBL">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const SIDE = (
    <Tooltip id="SIDE">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const BOXES = (
    <Tooltip id="BOXES">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const BASECURVE = (
    <Tooltip id="BASECURVE">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const BOTTOMDISTANCE = (
    <Tooltip id="BOTTOMDISTANCE">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const TOPDISTANCE = (
    <Tooltip id="TOPDISTANCE">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const COLOR = (
    <Tooltip id="COLOR">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const TINT = (
    <Tooltip id="TINT">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const EFFECTIVEDIA = (
    <Tooltip id="EFFECTIVEDIA">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const SPVD = (
    <Tooltip id="SPVD">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const THICKNESS = (
    <Tooltip id="THICKNESS">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );
  const POWERWISEID = (
    <Tooltip id="POWERWISEID">
      {ADDITIONAL_PLUS_POWER_IN_LOWER_PORTION}. {TO_LEARN_MORE},{' '}
      <a
        className="text-lowercase"
        href={`//${domainUrl}/understand-your-prescription.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        {CLICK_HERE}
      </a>
    </Tooltip>
  );

  const powerObj = {
    sph: 'Spherical',
    cyl: 'Cylindrical',
    axis: 'Axis',
    ap: 'AP',
    pd: 'PD',
    lensHeight: 'LENS HEIGHT',
    lensWidth: 'LENS WIDTH',
    bottomDistance: 'BOTTOM DISTANCE',
    topDistance: 'TOP DISTANCE',
    ed: 'ED',
    dbl: 'DBL',
    effectiveDia: 'EFFECTIVE DIA',
    boxes: 'BOXES',
    nearPD: 'NEAR PD',
    fittingHeight: 'FITTING HEIGHT',
    side: 'SIDE',
    baseCurve: 'BASE CURVE',
    color: 'COLOR',
    tint: 'TINT',
    svpd: 'SPVD',
    thickness: 'THICKNESS',
    powerwiseId: 'POWERWISE ID',
    types: {
      sph: Spherical,
      cyl: Cylindrical,
      axis: Axis,
      ap: AP,
      pd: PD_,
      lensHeight: LENSHEIGHT,
      lensWidth: LENSWIDTH,
      bottomDistance: BOTTOMDISTANCE,
      topDistance: TOPDISTANCE,
      ed: ED,
      dbl: DBL,
      effectiveDia: EFFECTIVEDIA,
      boxes: BOXES,
      nearPD: NEARPD,
      fittingHeight: FITTINGHEIGHT,
      side: SIDE,
      baseCurve: BASECURVE,
      color: COLOR,
      tint: TINT,
      svpd: SPVD,
      thickness: THICKNESS,
      powerwiseId: POWERWISEID,
    },
  };

  const filteredData = powersDetail?.result?.powerTypeList?.filter(res =>
    Object.keys(powerObj).includes(res.type)
  );

  const onChangeInputHandeler = (value, power, name) => {
    const dataObj = { ...enterData };
    dataObj[name][power] = value;
    successApiCall.enterDataFunc(dataObj);
    handlePowerValidation(dataObj);
    if (touchFields && touchFields.prescription !== true)
      setTouchFields({ ...touchFields, prescription: true });
  };

  const renderFields = () => {
    return filteredData?.map((res, key) => {
      if (res?.type?.toLowerCase() !== 'boxes') {
        return (
          <div key={key} className="parent-list power-block power-submit-panel">
            {/* Hide for now : Hover thing */}
            {/* <OverlayTrigger delayHide={1000} rootClose={1 && true} placement="top" overlay={powerObj.types[res.type]}>
                        <div className="power-submit-head heading heading-top">{powerObj[res.type]} ({res.type}) <i className="fa fa-question-circle fa-lg"></i></div>
                    </OverlayTrigger> */}
            <div className="power-submit-head heading heading-top">{res.label}</div>
            {/* Dropdown : Right */}
            {res.inputType === 'drop_down' &&
              (!hasSingleEye || (hasSingleEye && whichEye === 'right')) && (
                <DropDown
                  list={res?.powerDataList?.[0]?.value}
                  name="right"
                  openList={showRefDD}
                  power={res.type}
                  {...props}
                  ref={showRefDD => {
                    powerObj[res.type] = showRefDD;
                  }}
                  className="power-submit-dropdown"
                  defaultLabel={props?.enterData?.right?.[res.type] || 'Select'}
                  handleProductList={handleProductList}
                  openDropdown={openDropdown}
                />
              )}
            {/* Dropdown : Left */}
            {res.inputType === 'drop_down' &&
              (!hasSingleEye || (hasSingleEye && whichEye === 'left')) && (
                <DropDown
                  list={res?.powerDataList?.[0]?.value}
                  name="left"
                  openList={showRefDD}
                  power={res.type}
                  {...props}
                  ref={showRefDD => {
                    powerObj[res.type] = showRefDD;
                  }}
                  className="power-submit-dropdown"
                  defaultLabel={props?.enterData?.left?.[res.type] || 'Select'}
                  handleProductList={handleProductList}
                  openDropdown={openDropdown}
                />
              )}
            <div className="display-flex">
              {/* Input : Right */}
              {res.inputType === 'field' &&
                (!hasSingleEye || (hasSingleEye && whichEye === 'right')) && (
                  <div className="input-wrapper">
                    <input
                      className="input-field"
                      defaultValue={props?.enterData?.right?.[res.type] || ''}
                      type="number"
                      value={props?.enterData?.right?.[res.type] || ''}
                      onChange={e => onChangeInputHandeler(e?.target?.value, res.type, 'right')}
                    />
                  </div>
                )}
              {/* Input : Left */}
              {res.inputType === 'field' &&
                (!hasSingleEye || (hasSingleEye && whichEye === 'left')) && (
                  <div className="input-wrapper">
                    <input
                      className="input-field"
                      defaultValue={props?.enterData?.left?.[res.type] || ''}
                      type="number"
                      value={props?.enterData?.left?.[res.type] || ''}
                      onChange={e => onChangeInputHandeler(e?.target?.value, res.type, 'left')}
                    />
                  </div>
                )}
            </div>
          </div>
        );
      }
      return '';
    });
  };

  return (
    <>
      <div className="manual-presc-block">
        <div className="add-power-tabel power-submit-panel add-power-column power-colmn-five">
          <ul className="power-submit-panel text-uppercase">
            <li className="power-submit-head heading">{EYE}</li>
            {hasSingleEye && whichEye ? (
              <>
                <li className="power-submit-head heading">
                  {whichEye === 'left' ? LEFT_EYE : RIGHT_EYE}
                </li>
                <li className="power-submit-head heading"></li>
              </>
            ) : (
              <>
                <li className="power-submit-head heading">{RIGHT_EYE}</li>
                <li className="power-submit-head heading">{LEFT_EYE}</li>
              </>
            )}
          </ul>
          {powersDetail && renderFields()}
        </div>
        {errorMsg !== '' && (
          <div className="alert alert-danger err-msg" role="alert">
            {errorMsg}
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  powersDetail: state.success.powersDetail,
  errorMsg: state.success.errorMsg,
  showRefDD: state.success.showRefDD,
  enterData: state.success.enterData,
  localeInfo: state.common.localeInfo,
  dataLocale: state.locale,
});
const mapDispatchToProps = dispatch => ({
  successApiCall: bindActionCreators(successApiCall, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Prescriptions);
